module.exports = __webpack_public_path__ + "fonts/HKGrotesk-Light.5ad7c6f.otf";